const PAGE_TOGGLES_DEFAULT_TRUE = new Set([
  'integrations_page',
  'settings_page',
  'sales_page',
]);

/** Feature keys that stay on when missing from root (until admin overrides). */
const FEATURE_TOGGLES_DEFAULT_TRUE = new Set(['sales_feature', 'agents']);

function defaultWhenMissing(featureKey, defaultValue) {
  if (FEATURE_TOGGLES_DEFAULT_TRUE.has(featureKey)) return true;
  if (PAGE_TOGGLES_DEFAULT_TRUE.has(featureKey)) return true;
  const isPageLevel = featureKey && featureKey.endsWith('_page');
  return isPageLevel ? false : defaultValue;
}

/**
 * Pure resolver for feature toggle access (shared by hooks and sidebar grouping).
 */
export function resolveFeatureToggleAccess(user, globalToggles, featureKey, defaultValue = true) {
  if (featureKey === 'always_visible') {
    return defaultValue;
  }

  if (user?.role === 'admin' || user?.role === 'super-admin') {
    return true;
  }

  if (user?.featureToggles && typeof user.featureToggles === 'object') {
    if (Object.prototype.hasOwnProperty.call(user.featureToggles, featureKey)) {
      return user.featureToggles[featureKey] === true;
    }
  }

  if (globalToggles && globalToggles.length > 0) {
    const resolvedToggle = globalToggles.find(
      (t) => t.feature_key === featureKey || t.key === featureKey
    );

    if (resolvedToggle) {
      return resolvedToggle.enabled === true;
    }

    return defaultWhenMissing(featureKey, defaultValue);
  }

  return defaultWhenMissing(featureKey, defaultValue);
}

export function getNavItemFeatureKey(navItem) {
  return navItem.featureKey || 'always_visible';
}

export function getNavItemFeatureDefault(navItem) {
  if (navItem.featureKey === null) return true;
  // Sales (and similar) stay visible until root/plan/user disables them
  if (FEATURE_TOGGLES_DEFAULT_TRUE.has(navItem.featureKey)) return true;
  if (PAGE_TOGGLES_DEFAULT_TRUE.has(navItem.featureKey)) return true;
  return false;
}
